module.exports = __webpack_public_path__ + "icon-128-visualisation-area.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/icon-128-visualisation-area.png
// module id = 625
// module chunks = 11